'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

const label = {
  OnlineCode: 'js.modules.shared.SeeCode',
  OnlineDeal: 'js.modules.shared.GetDeal',
  OnlineSale: 'js.modules.shared.ViewSale',
};

function OfferRedemptionText({ className = '', type }) {
  return h(
    Translate,
    { tag: 'span', attrs: { class: className } },
    label[type] || label.OnlineSale
  );
}

module.exports = OfferRedemptionText;
